export function initializeExternal() {
  console.log("External links initialized");
  window.addEventListener("DOMContentLoaded", function externalLinks() {
    var anchors = document.getElementsByTagName("a");
    for (var i = 0; i < anchors.length; i++) {
      var href = anchors[i].getAttribute("href");
      // Check if href is blank, a hash, or an anchor on the same page
      if (!href || href === "#" || href.startsWith("#")) {
        continue; // Skip this iteration and move to the next anchor
      }
      if (anchors[i].hostname !== window.location.hostname) {
        anchors[i].setAttribute("target", "_blank");
        anchors[i].setAttribute("rel", "noopener");
        anchors[i].classList.add("external");
      }
    }
  });
}